// **********************************************************
// Landing Slider
// **********************************************************

const landingSlider = document.querySelectorAll('[data-slider="landing-slider"]');

const landingSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 800,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
};

landingSlider.forEach((el) => {
  const landingSliderParent = el.closest('.landing-module');
  const paginationElement = landingSliderParent.querySelector('.swiper-pagination');
  const arrowRight = landingSliderParent.querySelector('.arrow-right');
  const arrowLeft = landingSliderParent.querySelector('.arrow-left');

  landingSliderOptions.navigation.nextEl = arrowRight;
  landingSliderOptions.navigation.prevEl = arrowLeft;

  landingSliderOptions.pagination.el = paginationElement;

  new Swiper(el, landingSliderOptions);
});
